import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Credit,
  Nullable,
  UserCreditMoveType,
  UserWithToken,
  WithData,
  WithMeta,
} from '@ygoargentina/sdk/api/api.types';
import { z } from 'zod';

export const addCreditSchema = z.object({
  storeId: z.number().min(1, 'Selecciona una tienda'),
  userId: z.number().min(1, 'Selecciona un usuario'),
  amount: z.number().min(0.01, 'El monto debe ser mayor a 0'),
  type: z.nativeEnum(UserCreditMoveType),
  note: z.string().optional(),
});

export const listCredits = async (
  user: Nullable<UserWithToken>,
  variables: Record<string, unknown>
) =>
  getGraphQLQueryClient(user).request<WithMeta<Credit>>(
    gql`
      query credits($filters: UserCreditFilters) {
        data: credits(filters: $filters) {
          data {
            balance

            user {
              id
              name
              lastName
              cossyId
            }
          }
          meta {
            total
            perPage
            lastPage
          }
        }
      }
    `,
    { filters: variables }
  );

export const getUserCredits = async (
  user: Nullable<UserWithToken>,
  userId: number
) =>
  getGraphQLQueryClient(user).request<WithData<Credit>>(
    gql`
      query userCredits($userId: Int!) {
        data: userCredits(userId: $userId) {
          id
          balance
          user {
            id
            name
            lastName
            cossyId
          }
          store {
            id
            name
          }
          moves {
            id
            amount
            type
            note
            createdAt
          }
        }
      }
    `,
    { userId }
  );

export const depositUserCredit = async (
  user: Nullable<UserWithToken>,
  input: {
    userId: number;
    storeId: number;
    amount: number;
    type?: UserCreditMoveType;
    note?: string;
  }
) =>
  getGraphQLQueryClient(user).request<{ depositUserCredit: Credit }>(
    gql`
      mutation depositUserCredit($input: DepositUserCreditInput!) {
        depositUserCredit(input: $input) {
          id
          balance
          user {
            id
            name
            lastName
            cossyId
          }
        }
      }
    `,
    { input }
  );
